import React from "react";
import { IoMdClose } from "react-icons/io";
import { MdLogout } from "react-icons/md";

const TRANSLATIONS = {
  EN: {
    title: "Log Out",
    areYouSure: "Are you sure you want to log out?",
    subtext: "You will need to enter your credentials to log back in.",
    cancel: "Cancel",
    confirm: "Log Out",
  },
  ES: {
    title: "Cerrar Sesión",
    areYouSure: "¿Estás seguro de que deseas cerrar sesión?",
    subtext: "Tendrás que ingresar tus credenciales para volver a iniciar sesión.",
    cancel: "Cancelar",
    confirm: "Cerrar Sesión",
  },
};

const LogoutModal = ({
  isOpen,
  onClose,
  onConfirm,
  lang = "EN",
}) => {
  if (!isOpen) return null;

  const t = TRANSLATIONS[lang] || TRANSLATIONS.EN;

  return (
    <div
      className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50 p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden border border-primary/10 transition-all animate-fadeIn"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex justify-between items-center px-6 py-4 border-b border-primary/10 bg-gradient-to-r from-primary/5 via-white to-primary/5">
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-xl bg-primary/10 flex items-center justify-center text-primary shadow-xs">
              <MdLogout className="text-lg" />
            </div>
            <h2 className="font-roboto font-bold text-base text-primary uppercase tracking-wide">
              {t.title}
            </h2>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-full flex items-center justify-center text-gray-400 hover:text-primary hover:bg-[#F0EEF8] transition-colors"
          >
            <IoMdClose className="text-lg" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 flex flex-col items-center gap-3 text-center">
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#F0EEF8] to-primary/10 flex items-center justify-center text-primary shadow-inner">
            <MdLogout className="text-3xl text-primary" />
          </div>
          <h3 className="font-roboto font-bold text-lg text-gray-800 mt-1">
            {t.areYouSure}
          </h3>
          <p className="font-roboto text-xs text-gray-500 max-w-xs leading-relaxed">
            {t.subtext}
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end gap-3 px-6 pb-6 pt-1 border-t border-primary/10">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 sm:flex-initial px-5 py-2.5 rounded-xl font-roboto font-semibold text-xs uppercase tracking-wide text-gray-600 border border-primary/20 hover:bg-[#F0EEF8] transition-all text-center"
          >
            {t.cancel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="flex-1 sm:flex-initial px-6 py-2.5 rounded-xl font-roboto font-bold text-xs uppercase tracking-wide text-white bg-primary hover:bg-primary/90 transition-all shadow-sm hover:shadow text-center"
          >
            {t.confirm}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
